import React, { useContext } from "react"
import TypeIt from "typeit-react"
import classnames from "classnames"
import { ThemeContext } from "./layout"

export const TypedJS = ({ toggleModel, startAnimation }) => {
  const theme = useContext(ThemeContext)
  return (
    <div
      className={classnames(
        "flex",
        theme === "dark" ? "has-text-light" : "has-text-dark"
      )}
    >
      {startAnimation && (
        <TypeIt
          className="typed-text"
          getBeforeInit={instance => {
            instance
              .type("Hi, I'm Neraj")
              .pause(750)
              .delete(3)
              .pause(500)
              .type("eraj Sharma!")
              .pause(1000)
              .break()
              .type("<span>Engineer, developer.</span>")
              .pause(1000)
              .break()
              .type("<span>Open source enthusiast.</span>")
              .pause(500)
              .exec(() => {
                toggleModel(true)
              })
            return instance
          }}
          options={{
            // lifeLike: true,
            waitUntilVisible: true,
            startDelay: 500,
            html: true,
          }}
        />
      )}
    </div>
  )
}
